import type { ReactNode } from 'react';

interface PageShellProps {
  title: string;
  subtitle?: string;
  children?: ReactNode;
}

/**
 * Generic page wrapper used by every screen until the per-feature UI is built.
 * Provides a header + scrollable body with consistent padding.
 */
export function PageShell({ title, subtitle, children }: PageShellProps) {
  return (
    <div className="flex h-full flex-col">
      <header className="border-b border-bg-secondary px-4 py-4">
        <h1 className="text-xl font-bold text-text">{title}</h1>
        {subtitle && <p className="mt-1 text-sm text-hint">{subtitle}</p>}
      </header>
      <div className="flex-1 px-4 py-4">{children}</div>
    </div>
  );
}
